
import axios from '../config/axios';

export const url = '/api/eventoyl90t'


export const createeventoyl90t = ({
  token,
	nombrecompletob9gnh,
	correovfh23,
	telfononf206,
	cantidaddepersonasd96qf,
	descripcinns3bw,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombrecompletob9gnh && correovfh23 && cantidaddepersonasd96qf ) {

    axios.post(`${url}//create/basic/69cd7523b08e22defc4d8a56`, {
		nombrecompletob9gnh,
		correovfh23,
		telfononf206,
		cantidaddepersonasd96qf,
		descripcinns3bw,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombrecompletob9gnh) {
		reject({
			status: 'error',
			info: 'Nombre completo no esta definido',
		});
	}  else if (!correovfh23) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!cantidaddepersonasd96qf) {
		reject({
			status: 'error',
			info: 'Cantidad de Personas no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

